import {
  ShippingsCreateBody,
  ShippingsListResponse,
  ShippingsItem,
  ShippingsDetailResponse,
} from "utils/api/client/types"

export class Shippings {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: ShippingsCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<{ data: ShippingsItem }> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/shippings`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: ShippingsCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ShippingsItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/shippings/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ShippingsListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/shippings`, {
        headers,
        query: queryParams,
      })
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ShippingsDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/shippings/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/shippings/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
